import { combineReducers } from 'redux';
import countries from './countries';
import cntryInfo from './cntryInfo';

export default combineReducers({
  countries,
  cntryInfo,
});
